import axios from "axios";
import Qs from "qs";
import router from '@/router';
import store from '@/store/index';

axios.defaults.withCredentials = true; // 允许跨域携带cookie
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.baseURL = process.env.VUE_APP_BASE_API; //添加请求基础路径

// 请求拦截
axios.interceptors.request.use(config => {
  if (localStorage.getItem("token")) {
    config.headers.authorization = "Bearer " + localStorage.getItem("token");
    config.headers["x-authorization"] = "Bearer " + localStorage.getItem("refreshToken");
  }
  return config;
});

//响应拦截
axios.interceptors.response.use(
  response => {
    let token = response.headers["access-token"];
    if (token) {
      localStorage.setItem("token", token);
    }

    let refreshToken = response.headers["x-access-token"];
    if (refreshToken) {
      localStorage.setItem("refreshToken", refreshToken);
    }

    return response;
  },
  error => {
    if (error.response) {
      if (error.response) {
        if (error.response.status == 401) {
          localStorage.clear();
          // location.href = '/login';
          store.commit("setLogined", false);
          router.push(
            "/login?returnUrl=" +
            encodeURIComponent(router.currentRoute.fullPath));
        }
      }
      return Promise.reject(error.response.data); // 返回接口返回的错误信息
    }
  }
);

/**
 * todo axios配置参数
 * @type {{method: string, contentType: string}}
 */
export function axiosOptions(method, contentType, responseType) {
  var object = new Object();
  object.method = method;
  object.contentType = contentType;
  object.responseType = responseType;
  return object;
}

/*
  todo 暴露请求对象
 */
export const axiosRequest = (url, postData = {}, options = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: (options && options.method) || 'post',
      url: isGetUrl(url, options.method, postData),
      params: isGet(postData, options.method),
      data: postData,
      /*处理request数据*/
      transformRequest: [function (data) {
        if (options && options.contentType) {
          return JSON.stringify(data);
        } else {
          return Qs.stringify(data, {
            indices: false
          })
        }
      }],
      headers: {
        'Content-Type': (options && options.contentType) || 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      responseType: (options && options.responseType) || 'json'
    }).then((res) => {
      if (options.responseType) {
        resolve(res);
      } else {
        let response = res.data;
        resolve(response);
      }
    }).catch((error) => {
      reject(error)
    })
  })
}

function isGet(data, method) {
  if (method && method == 'get') {
    return data;
  } else {
    return null;
  }
}

function isGetUrl(url, method, data) {
  if (method && method == 'get' && data && JSON.stringify(data) != '{}') {
    // return url + "?_t=" + Date.parse(new Date()) / 1000
    url = url + "?" + tansParams(data).slice(0, -1);
    return url;
  } else {
    return url;
  }
}

export function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof value[key] !== "undefined") {
            // let params = propName + "[" + key + "]";
            let params = propName;
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}
